import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex align-center ga-2 flex-wrap" }

import {openFilterDialog, openOrderInformationDialog, openTaskInformationDialog, useGlobalSetting} from "@/lib/utils";
import AssetSearch from "@/components/inputs/AssetSearch.vue";
import {useTheme} from "vuetify/framework";
import {AssetFetcher, AssetItem} from "@/types/Asset";
import {SortItem} from "vuetify/lib/components/VDataTable/composables/sort";
import {Component, onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";

export interface SearchTerm {
  id: string,
  title: string,
  assignee: string,
}

/*export type Header<T = Record<string, any>> = {
  key: 'data-table-group' | 'data-table-select' | 'data-table-expand' | (string & {});
  value?: SelectItemKey<T>;
  title?: string;
  fixed?: boolean;
  align?: 'start' | 'end' | 'center';
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  nowrap?: boolean;
  headerProps?: Record<string, any>;
  sortable?: boolean;
  filter?: FilterFunction;
  disabled?: boolean;
  canBeFiltered?: boolean;
  icon?: string;
  checkbox?: boolean;
  tab?: string;
  custom?: boolean;
  filterComponent?: Component;
  filterProps?: Record<string, any>;

  displayComponent?: Component;
  displayProps?: Record<string, any>;
};*/

export interface PaginationOptions {
  page: number;
  itemsPerPage: number;
}

interface Props {
  headers: any[],
  displayHeader: any[],
  fetchData: () => Promise<void>,
  title: string,
  icon?: string
  assetList?: AssetItem[],
  assetFetcher?: AssetFetcher,
  list: any[],
  totalItems: number,
  assetKey: string | string[],
  assetPlaceholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UniversalList',
  props: /*@__PURE__*/_mergeModels({
    headers: {},
    displayHeader: {},
    fetchData: {},
    title: {},
    icon: { default: "mdi-factory" },
    assetList: {},
    assetFetcher: {},
    list: {},
    totalItems: {},
    assetKey: { default: "title" },
    assetPlaceholder: {}
  }, {
    "searchTerm": {},
    "searchTermModifiers": {},
    "paginationOptions": {},
    "paginationOptionsModifiers": {},
    "sortOptions": {},
    "sortOptionsModifiers": {},
  }),
  emits: ["update:searchTerm", "update:paginationOptions", "update:sortOptions"],
  setup(__props: any) {

const searchTerms = _useModel(__props, 'searchTerm');
const paginationOptions = _useModel<PaginationOptions>(__props, 'paginationOptions');
const sortBy = _useModel<SortItem[]>(__props, 'sortOptions');

const props = __props

const globalSettings = useGlobalSetting();

const route = useRoute()
const router = useRouter()
const isReady = ref(false)

//TODO: synct nicht mit filter menu
function syncFiltersToUrl() {
  const cleanFilters = Object.fromEntries(
      Object.entries(searchTerms.value as Record<string, any>)
          .filter(([_, v]) => v !== '' && v != null)
  )
  router.replace({query: cleanFilters})
}

// Lokale fetchData überschattet props.fetchData
// Template verwendet automatisch diese Funktion
const fetchData = async () => {
  if (!isReady.value) return
  syncFiltersToUrl()
  await props.fetchData()
}

onMounted(async () => {
  if (Object.keys(route.query).length > 0) {
    Object.assign(searchTerms.value, route.query)
  }
  isReady.value = true
  await props.fetchData()  // Hier direkt props.fetchData, URL ist schon aus Query
})


function openDialog(id: number, orderId: number): void {
  if (props.headers.some(header => header.key == 'id') && props.headers.some(header => header.key == 'orderId')) {
    openTaskInformationDialog(orderId, id)
  } else {
    openOrderInformationDialog(id)
  }
}

function openFilter() {
  openFilterDialog(searchTerms, sortBy, fetchData, props.headers);
}

function handleBlur() {
  if (globalSettings.isMobile) {
    props.fetchData();
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { border: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_locale_provider, { locale: "de" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table_server, {
            options: paginationOptions.value,
            "onUpdate:options": [
              _cache[1] || (_cache[1] = ($event: any) => ((paginationOptions).value = $event)),
              fetchData
            ],
            "sort-by": sortBy.value,
            "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
            headers: props.displayHeader,
            items: _ctx.list,
            "items-length": _ctx.totalItems,
            "items-per-page": paginationOptions.value?.itemsPerPage,
            loading: _unref(globalSettings).isLoading,
            hover: "",
            style: _normalizeStyle({
            background: `${_unref(useTheme)().current.value.colors.background}`
          })
          }, _createSlots({
            loading: _withCtx(() => [
              _createVNode(_component_v_skeleton_loader, { type: "table-row@10" })
            ]),
            top: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                justify: "space-between",
                style: _normalizeStyle({
                background: `linear-gradient(to bottom, ${_unref(useTheme)().current.value.colors.primary} -50%, ${_unref(useTheme)().current.value.colors.background} 40%)`
              }),
                class: "pa-2 pa-md-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: _ctx.$slots['title-append'] ? 3 : 2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_toolbar_title, { class: "d-flex justify-start flex-grow-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "medium-emphasis",
                              icon: _ctx.icon,
                              size: "x-small",
                              start: ""
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                          ]),
                          _: 1
                        }),
                        _renderSlot(_ctx.$slots, "title-append")
                      ])
                    ]),
                    _: 3
                  }, 8, ["md"]),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: _ctx.$slots['title-append'] ? 9 : 10
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AssetSearch, {
                        modelValue: searchTerms.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerms).value = $event)),
                        "asset-keys": _ctx.assetKey,
                        items: _ctx.assetList,
                        "fetch-items": _ctx.assetFetcher,
                        placeholder: _ctx.assetPlaceholder,
                        "on-setting": openFilter,
                        "on-submit": fetchData,
                        onKeydown: _withKeys(fetchData, ["enter"]),
                        inputmode: "text",
                        enterkeyhint: "done"
                      }, null, 8, ["modelValue", "asset-keys", "items", "fetch-items", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["md"])
                ]),
                _: 3
              }, 8, ["style"])
            ]),
            "no-data": _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "Keine Ergebnisse gefunden!", -1)),
              _createVNode(_component_v_btn, {
                border: "",
                "prepend-icon": "mdi-backup-restore",
                rounded: "lg",
                text: "Neu Laden",
                variant: "text",
                onClick: fetchData
              })
            ]),
            _: 2
          }, [
            (_unref(globalSettings).isMobile)
              ? {
                  name: "headers",
                  fn: _withCtx(() => []),
                  key: "0"
                }
              : undefined,
            (!_unref(globalSettings).isMobile)
              ? {
                  name: "thead",
                  fn: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.displayHeader, (header) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: header.key,
                            class: "pa-2"
                          }, [
                            (header.filterComponent)
                              ? (_openBlock(), _createBlock(_resolveDynamicComponent(header.filterComponent), _mergeProps({
                                  key: 0,
                                  modelValue: searchTerms.value[header.key],
                                  "onUpdate:modelValue": ($event: any) => ((searchTerms.value[header.key]) = $event)
                                }, { ref_for: true }, header.filterProps, {
                                  onKeydown: _withKeys(fetchData, ["enter"])
                                }), null, 16, ["modelValue", "onUpdate:modelValue"]))
                              : (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 1,
                                  modelValue: searchTerms.value[header.key],
                                  "onUpdate:modelValue": ($event: any) => ((searchTerms.value[header.key]) = $event),
                                  label: `in ${header.title} suchen...`,
                                  dense: "",
                                  density: "compact",
                                  "hide-details": "",
                                  clearable: "",
                                  "prepend-inner-icon": "mdi-magnify",
                                  style: {"width":"100%"},
                                  variant: _unref(globalSettings).globalTextVariant,
                                  onKeydown: _withKeys(fetchData, ["enter"]),
                                  disabled: header.disabled
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "variant", "disabled"]))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  key: "1"
                }
              : undefined,
            _renderList(Object.keys(_ctx.$slots).filter(name => name !== 'title-append'), (slot) => {
              return {
                name: slot,
                fn: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
                ])
              }
            })
          ]), 1032, ["options", "sort-by", "headers", "items", "items-length", "items-per-page", "loading", "style"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})